import { render, staticRenderFns } from "./TouchpointInfoConnectionList.vue?vue&type=template&id=6b44001c&scoped=true&"
import script from "./TouchpointInfoConnectionList.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfoConnectionList.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointInfoConnectionList.vue?vue&type=style&index=0&id=6b44001c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44001c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b44001c')) {
      api.createRecord('6b44001c', component.options)
    } else {
      api.reload('6b44001c', component.options)
    }
    module.hot.accept("./TouchpointInfoConnectionList.vue?vue&type=template&id=6b44001c&scoped=true&", function () {
      api.rerender('6b44001c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointInfoConnectionList.vue"
export default component.exports